<template>
	<fragment>
		<img class="jackpot-heading" src="@/assets/images/headings/jackpot.png" alt="Jackpot" />
		<div class="wysiwyg-content desciption" v-html="description" />
		<div class="money-reward">+{{ amount | currency }}</div>
		<MarqueeButton class="jackpot" :action="$parent.complete">{{ button_text }}</MarqueeButton>
	</fragment>
</template>

<script>
import MarqueeButton from "@/components/base/MarqueeButton";

export default {
	name: 'Jackpot',
	components: {
		MarqueeButton,
	},
	props: {
		amount: {
			type: Number,
			required: true,
		},
		button_text: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			required: true,
		},
	},
	mounted() {
		this.$store.dispatch("sound/fx/play", { id: "jackpot" });
	},
};
</script>

<style lang="scss" scoped>
	.jackpot-heading {
		position: relative;
		margin: 0 0 20px;
		width: 80%;
		max-height: 75px;

		@include tablet { max-height: 90px; }
	}

	.marquee-button { margin: 20px 0 0; }
</style>
